import { authGuard } from '@auth0/auth0-vue';
import store from '@/store';
import { RouteNames } from '@/data/routes';

import UserLayout from '@/pages/users/UserLayout.vue';
import UserEditSecondaryPage from '@/pages/users/UserEditSecondaryPage.vue';
import UserListPage from '@/pages/users/UserListPage.vue';
import { RouteLocation } from 'vue-router';
import { UserResponseDto } from '@clearbanc/baus-sdk';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: 'owners',
  component: UserLayout,
  beforeEnter: authGuard,
  children: [
    {
      path: '',
      name: RouteNames.OWNERS.INDEX,
      alias: '/pay-vendors/business-profile/owners/list',
      component: UserListPage,
      meta: {
        hasAccess: ({ store }) =>
          !!store?.getters.isBusinessDetailsStepComplete,
        fallbackRoute: RouteNames.PROFILE.INDEX,
      },
    },
    {
      path: 'new',
      alias: '/pay-vendors/business-profile/owners/new',
      name: RouteNames.OWNERS.NEW,
      component: UserEditSecondaryPage,
    },
    {
      path: ':id',
      name: RouteNames.OWNERS.EDIT,
      component: UserEditSecondaryPage,
      beforeEnter: (to: RouteLocation) => {
        const selectedOwner = store.getters.allUsers.find(
          (owner: UserResponseDto) => owner.id === to.params.id,
        );
        if (
          !selectedOwner ||
          store.getters.businessHasPendingBillContractOrActiveAdvance
        ) {
          return { name: RouteNames.OWNERS.INDEX };
        }
        if (selectedOwner.isPrimary) {
          return {
            name: RouteNames.USER.INDEX,
          };
        }
        return true;
      },
    },
  ],
});
